export const UNKNOWN_STRING_DEFAULT = 'N/A'

export const USER_ID_KEY = 'up:userId'
